// Actions pour le reducer
export const ACTIONS = {
    FETCH_INIT: 'FETCH_INIT',
    FETCH_SUCCESS: 'FETCH_SUCCESS',
    FETCH_FAILURE: 'FETCH_FAILURE',
    POST_INIT: 'POST_INIT',
  POST_SUCCESS: 'POST_SUCCESS',
  POST_FAILURE: 'POST_FAILURE',
  DELETE_INIT: 'DELETE_INIT',
  DELETE_SUCCESS: 'DELETE_SUCCESS',
  DELETE_FAILURE: 'DELETE_FAILURE',
  FETCH_DISABLED : 'FETCH_DISABLED'

  };
  
  // Le reducer qui gère les actions
  export const apiReducer = (state, action) => {
    switch (action.type) {
      case ACTIONS.FETCH_INIT:
      case ACTIONS.POST_INIT:
      case ACTIONS.DELETE_INIT:
        return {
          ...state,
          isLoading: true,
          isError: false,
        };
      case ACTIONS.FETCH_SUCCESS:
      case ACTIONS.POST_SUCCESS:
      case ACTIONS.DELETE_SUCCESS:
        return {
          ...state,
          isLoading: false,
          isError: false,
          data: action.payload,
        };
      case ACTIONS.FETCH_FAILURE:
      case ACTIONS.POST_FAILURE:
      case ACTIONS.DELETE_FAILURE:
        return {
          ...state,
          isLoading: false,
          isError: true,
          // la raison, quand l'appelant l'a donnée (statut HTTP, ou 0 sans
          // réponse) : un écran peut la dire au lieu de se taire
          erreur: action.payload ?? state.erreur ?? null,
        };
      case ACTIONS.FETCH_DISABLED:
        return {
          ...state,
          isLoading: false,
          isError: false,
          data: action.payload || state.data, // Conserver les données actuelles si non spécifiées
        };
      default:
        throw new Error(`Action type non prise en charge : ${action.type}`);
    }
  };